import { createBrowserHistory as history } from 'history';
import { config } from './contexts/UrlContext';

export default history();
